import React, { useEffect, useState } from 'react';
import { Sparkles, ArrowRight, Stethoscope, FileText } from 'lucide-react';
import '../styles/adbanner.css';

const AdBanner = ({ type = 'square' }) => {
  const [adLoaded, setAdLoaded] = useState(false);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        setAdLoaded(true);
      }
    } catch (e) {
      console.warn("External ad loader failed to initialize, displaying fallback house ad.", e);
    }
  }, []);

  const getFallbackContent = () => {
    if (type === 'leaderboard') {
      return (
        <a href="/sushruta-samhita" className="fallback-house-ad ad-leaderboard-fallback">
          <div className="fallback-ad-content">
            <span className="fallback-ad-tag"><Sparkles size={12} /> Platform Spotlight</span>
            <div className="fallback-ad-text">
              <h4>Master Ancient Shalya Tantra</h4>
              <p>Explore the trilingual, AI-annotated digital archive of the Sushruta Samhita with modern clinical references.</p>
            </div>
            <span className="fallback-ad-btn">Open Library <ArrowRight size={14} /></span>
          </div>
        </a>
      );
    }

    if (type === 'skyscraper') {
      return (
        <a href="/research" className="fallback-house-ad ad-skyscraper-fallback">
          <div className="fallback-ad-content">
            <div className="fallback-ad-icon-circle">
              <FileText size={32} />
            </div>
            <h4>Vedic Surgery Research Hub</h4>
            <p>Access hundreds of verified BAMS & MS clinical study publications, evidence-based reports, and research papers bridging Ayurvedic and modern surgical procedures.</p>
            <span className="fallback-ad-btn">Search Papers <ArrowRight size={14} /></span>
          </div>
        </a>
      );
    }

    // Default to square/rectangle
    return (
      <a href="/treatment" className="fallback-house-ad ad-square-fallback">
        <div className="fallback-ad-content">
          <div className="fallback-ad-icon-circle">
            <Stethoscope size={24} />
          </div>
          <h4>Prakriti Assessments</h4>
          <p>Instantly evaluate patient constitutional balance (Tridosha) using our dynamic, NCISM-aligned Clinical AI engine.</p>
          <span className="fallback-ad-btn">Start Test <ArrowRight size={14} /></span>
        </div>
      </a>
    );
  };

  const adClient = process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-fake-placeholder';
  const adSlot = type === 'leaderboard'
    ? (process.env.REACT_APP_ADSENSE_LEADERBOARD_SLOT || '0987654321')
    : (process.env.REACT_APP_ADSENSE_SQUARE_SLOT || '1234567890');

  return (
    <div className={`workspace-ad-wrapper ad-type-${type}`}>
      <span className="sponsored-label">Sponsored</span>
      {!adLoaded && getFallbackContent()}
      <ins className="adsbygoogle"
           style={{ display: adLoaded ? 'block' : 'none' }}
           data-ad-client={adClient}
           data-ad-slot={adSlot}
           data-ad-format={type === 'leaderboard' ? 'horizontal' : type === 'skyscraper' ? 'vertical' : 'rectangle'}
           data-full-width-responsive="true"></ins>
    </div>
  );
};

export default AdBanner;
